import { render, staticRenderFns } from "./addDocumentType.vue?vue&type=template&id=1f109ace&"
import script from "./addDocumentType.vue?vue&type=script&lang=js&"
export * from "./addDocumentType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports